import HttpError from './HttpError';

export default class NoImportableAtsApplicationsError extends HttpError {}
